import styled from 'styled-components';

export const Container = styled.div.attrs(() => ({ className: 'Container' }))`
  display: block;
`;

export const Content = styled.div.attrs(() => ({ className: 'Content' }))`
  display: block;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  max-width: 100%;
  min-width: 100%;
`;

export const ContenTooltip = styled.p.attrs(() => ({ className: 'ContenTooltip' }))`
  margin: 0;
  font-size: 14px;
  color: #748C98;
  position: absolute;
  width: auto;
  max-width: 250px;
  background: #fff;
  padding: 10px;
  left: ${(props) => `${props.theme.left}px`};
  top: ${(props) => `${props.theme.top}px`};
  z-index: 8000;
  border: solid 2px #ACC2D3;
  border-radius: 5px;
  display: block;
  word-break: break-word;
  white-space: initial;

  ul {
    margin: 0;
    padding-left: 0;

    li {
      list-style-position: inside;
    }
  }
`;
